module.exports = __webpack_public_path__ + "20ff1298be3524a83f62c555230a11f1.png";